import { render, staticRenderFns } from "./ShortcutsView.vue?vue&type=template&id=0961a934&scoped=true&"
import script from "./ShortcutsView.vue?vue&type=script&lang=js&"
export * from "./ShortcutsView.vue?vue&type=script&lang=js&"
import style0 from "./ShortcutsView.vue?vue&type=style&index=0&id=0961a934&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0961a934",
  null
  
)

export default component.exports